import React from 'react'
import Header from '../../components/Header/Header';
import ProfileForm from '../../components/ProfileForm/ProfileForm';
function ProfilePage() {
  return (
    <Header>
      <ProfileForm />
    </Header>
  )
}

export default ProfilePage;
